import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Business Details"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-6" }, [
    /*#__PURE__*/_createTextVNode(" If you need more info, please check out "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "link-primary fw-bolder"
    }, "Help Page"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_3 = { class: "fv-row mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Business Name", -1)
const _hoisted_5 = { class: "fv-row mb-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Shortened Descriptor"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, " Customers will see this shortened version of your statement descriptor ", -1)
const _hoisted_8 = { class: "fv-row mb-10" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Corporation Type", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "S Corporation", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "C Corporation", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Sole Proprietorship", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Non-profit", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "4" }, "Limited Liability", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "5" }, "General Partnership", -1)
const _hoisted_17 = { class: "fv-row mb-10" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Business Description", -1)
const _hoisted_19 = { class: "fv-row mb-0" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Contact Email", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Field, {
        name: "businessName",
        class: "form-control form-control-lg",
        value: "Keenthemes Inc."
      }),
      _createVNode(_component_ErrorMessage, {
        name: "businessName",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_Field, {
        name: "businessDescriptor",
        class: "form-control form-control-lg",
        value: "KEENTHEMES"
      }),
      _createVNode(_component_ErrorMessage, {
        name: "businessDescriptor",
        class: "fv-plugins-message-container invalid-feedback"
      }),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(_component_Field, {
        name: "businessType",
        class: "form-select form-select-lg form-select-solid",
        "data-control": "select2",
        "data-placeholder": "Select...",
        "data-allow-clear": "true",
        "data-hide-search": "true",
        as: "select"
      }, {
        default: _withCtx(() => [
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          _hoisted_13,
          _hoisted_14,
          _hoisted_15,
          _hoisted_16
        ]),
        _: 1
      }),
      _createVNode(_component_ErrorMessage, {
        name: "businessType",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createVNode(_component_Field, {
        type: "text",
        name: "businessDescription",
        class: "form-control form-control-lg",
        rows: "3"
      })
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createVNode(_component_Field, {
        name: "businessEmail",
        class: "form-control form-control-lg",
        value: "corp@support.com"
      }),
      _createVNode(_component_ErrorMessage, {
        name: "businessEmail",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ])
  ]))
}